import { ApiType } from "@gymflow/common";
import { ClubClassesSettingsDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useMutationAppClassesSettings({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: ClubClassesSettingsDTO) => {
      return (await api.clubApi.updateAppClassesSettings(data)).data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: clubQueryKeys.appClassesSettings(clubId),
      });
    },
  });
}
